import React from 'react'
import { Icon, IconProps } from '../components/Icon'
const SvgBlock: React.FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 20a8 8 0 100-16 8 8 0 000 16zM6.353 6.353l11.294 11.294"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
export default SvgBlock
